import { Sidebar } from "../SideBar";
import Dashboard from "../ui/Dashboard";
import { useState } from "react";

export default function SalesLayOut({ children }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="flex min-h-screen bg-background/50">
            <Sidebar open={open} setOpen={setOpen} />
            <div className="flex-1  bg-[#ffffff]">
                <Dashboard setOpen={setOpen} />
                <main className="flex-1 pt-[52px] xs:pt-[56px] rs:pt-[72px]">
                    {children}
                </main>
            </div>
        </div>
    )
}